import { getAxiosInstance } from '@/services/axiosConfig';

const axiosInstance = getAxiosInstance();

export const getCivitModelVersionsByNumericalId = async (civitModelUrl: string) => {
  const civitId = civitModelUrl.split('/').filter((part) => /^\d+$/.test(part))[0];
  const res = await axiosInstance.get<{ modelVersions: { id: string }[]; name: string }>(`/v1/models/civit/${civitId}`);
  return res.data;
};

export const getCivitModelByVersionId = async (versionId: string) => {
  const res = await axiosInstance.get<{
    air: string;
    images: { url: string }[];
  }>(`/v1/models/civit/version/${versionId}`);
  return res.data;
};
